<template>
  <div v-loading="loading" :class="{'u-mt4': loading}">
    <div class="claim-block" v-if="claim">
      <!--  Claim Info  -->
      <div class="claim-description u-mb4">
        <div class="claim-description__main">
          <div class="claim-description__title">
            <h1>{{ t('claims.claim_#', {number: claimDataFromList.claim_number}) }}</h1>
            <div>
              <div>
                <span class="u-pr1">{{ t('claims.loss_date_title') }}:</span>
                <span>{{ claim.loss_date | dateFormatWithTimeZone('MM-DD-YYYY hh:mm A z', claim.loss_timezone) }}</span>
              </div>
            </div>
          </div>
          <div class="claim-description__title_subtitle">
            {{t('claims.policy_select_prefix')}}{{claim.policy_number}}
          </div>
        </div>
        <el-row :gutter="20">
          <el-col :sm="24" :md="24">
            <div v-if="claim.preferred_phone">
              <h3 class="subheader">{{ t('global.phone_number') }}</h3>
              <div class="claim-description__content">
                <bc-phone-national-format :phone="claim.preferred_phone" />
              </div>
            </div>
          </el-col>
          <el-col :sm="24" :md="12">
            <h3 class="subheader">{{ riskLabel }}</h3>
            <div class="claim-description__content" v-for="risk in claim.risks" :key="risk.id">
              {{ risk.name }}
            </div>
          </el-col>


          <el-col :sm="24" :md="12">
            <h3 class="subheader">{{ t('claims.loss_description_title') }}</h3>
            <div class="claim-description__content claim-description__content_scroll">{{ claim.loss_description }}</div>
          </el-col>

        </el-row>
      </div>
  
      <!--  Photos Section  -->
      <div class="u-mb4">
        <bc-claim-photo-preview v-if="!hideClaimsLossPhotos" :photos="claim.photos" @reloadClaimImage="loadClaim"/>
      </div>
      
      <!--  Adjusters Section  -->
      <div v-if="!hideClaimsAdjusters">
        <h2 class="secondary-title u-mb3">
          {{ t('claims.adjusters_section_title') }}
          <span v-if="claim.adjusters && claim.adjusters.length > 0">({{ claim.adjusters.length }})</span>
        </h2>
        <div v-if="claim.adjusters.length">
          <div v-for="adjuster in claim.adjusters" :key="adjuster.id"  class="claim-adjusters u-mb4">
            <bc-adjusters-list :name="adjuster.name" :imageData="{photoId: adjuster.photo_id}" :contact="adjuster"/>
          </div>
        </div>
        <div v-else class="claim-adjusters u-mb4">
          <div v-if="!claim.adjusters.length" class="u-mt2 u-mb4">
            {{ t('claims.claim_no_adjusters_yet_text') }}
          </div>
        </div>
      </div>
      
    </div>
  </div>
</template>


<script>
import ClaimPhotoPreview from '@/pages/claims/claims-photo-preview.component'
import AdjustersList from '@/components/adjusters-list'
import { mapActions, mapGetters } from 'vuex'

export default {
  components: {
    'bc-claim-photo-preview': ClaimPhotoPreview,
    'bc-adjusters-list': AdjustersList,
  },
  computed: {
    ...mapGetters('claims', ['claimById']),
    ...mapGetters('policies', ['riskLabelByPolicy', 'policyByNumber']),
    claimDataFromList () {
      // TODO current getGen3Claim does not return claim number. We fetch it from store. Need to update BA EP
      return this.claimById(this.claimId)
    },
    hideClaimsAdjusters () {
      return this.setting('claims.hide_claims_adjusters')
    },
    hideClaimsLossPhotos () {
      return this.setting('claims.hide_claims_loss_photos')
    },
    riskLabel () {
      let policy = this.policyByNumber(this.claim.policy_number)
      return this.riskLabelByPolicy(policy, this.claim.risks.length > 1)
    },
  },
  methods: {
    ...mapActions('claims', ['getGen3Claim']),
    async loadClaim () {
      this.loading = true
      try {
        let response = await this.getGen3Claim(this.claimId)
        this.claim = response.data
      } catch (e) {
        this.loading = false
        let cause = (e.response && e.response.cause) ? e.response.cause : 'global.error'
        this.$elAlert(this.t(cause), this.t('global.notice'))
        return
      }
      this.loading = false
    },
  },
  created () {
    this.loadClaim()
  },
  data () {
    return {
      claim: null,
      loading: false,
      claimId: this.$route.params.claimId
    }
  }
}
</script>
